import { Shield as ShieldIcon, Smartphone as DeviceIcon, FileText as RulesIcon, Clock as ClockIcon } from 'lucide-react'
import { useOnboarding } from './OnboardingFlow'

export default function WelcomeStep() {
  const { nextStep } = useOnboarding()

  const features = [
    { icon: <DeviceIcon size={32} className="text-brand" />, title: 'Manage Devices', description: 'Control and monitor all your family devices' },
    { icon: <RulesIcon size={32} className="text-brand" />, title: 'Set Rules', description: 'Create content filters and app restrictions' },
    { icon: <ClockIcon size={32} className="text-brand" />, title: 'Schedule Time', description: 'Set screen time limits and schedules' },
  ]

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 text-center">
      <div className="flex justify-center mb-6">
        <div className="w-24 h-24 rounded-2xl bg-brand-light flex items-center justify-center">
          <ShieldIcon size={64} className="text-brand" />
        </div>
      </div>

      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
        Welcome to Unbreakable
      </h1>
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        Let&apos;s get you set up in just a few minutes. We&apos;ll guide you through connecting your devices and setting up parental controls.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {features.map((feature, index) => (
          <div key={index} className="p-4 rounded-xl bg-brand-light">
            <div className="flex justify-center mb-3">
              {feature.icon}
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">{feature.title}</h3>
            <p className="text-sm text-gray-500">{feature.description}</p>
          </div>
        ))}
      </div>

      <button
        onClick={nextStep}
        className="w-full sm:w-auto px-8 py-3 bg-brand text-white rounded-xl font-medium hover:bg-brand-hover transition-colors"
      >
        Get Started
      </button>
    </div>
  )
}
